// @flow

import NestedResource from 'speed-js-core/src/api/NestedResource';

export default class CaseEventsResource extends NestedResource {
    basePath: string = 'cases/cases/{parent}/events/';

    objectPath: string = 'cases/cases/{parent}/events/{ident}/';
}
